import InfoLayout from "../components/landing/InfoLayout";
import LegalDoc from "../components/landing/LegalDoc";

const sections = [
    {
        id: "alcance",
        title: "Alcance",
        body: <>
            <p>Esta Política explica qué datos recopila MiQRapp (en adelante, “la Plataforma”), para qué los usa y cómo los protege. Aplica a quienes crean una cuenta para armar su catálogo y a quienes visitan esos catálogos.</p>
            <p>El responsable de los datos es Franco Fenoglio, CUIT 20-41740222-6, con domicilio en Bragado, provincia de Buenos Aires. Contacto: <a href="mailto:contacto@miqrapp.com">contacto@miqrapp.com</a>.</p>
            <p>La Plataforma no está dirigida a menores de 18 años y no recopilamos a sabiendas datos de menores.</p>
        </>
    },
    {
        id: "datos",
        title: "Datos que recopilamos",
        body: <>
            <p>Solo pedimos lo necesario para que tu catálogo funcione:</p>
            <ul>
                <li><strong>Cuenta:</strong> tu email y, si entrás con Google, el nombre asociado a esa cuenta.</li>
                <li><strong>Negocio:</strong> nombre, nombre de usuario, descripción, dirección, teléfono, horarios, logo y colores del catálogo.</li>
                <li><strong>Productos:</strong> nombre, descripción, precio, categoría y foto de cada producto o servicio.</li>
                <li><strong>Suscripción:</strong> si tenés Pro, el estado y el identificador de tu suscripción en Mercado Pago. Nunca recibimos ni guardamos los datos de tu tarjeta.</li>
            </ul>
            <p>A quienes solo visitan un catálogo no les pedimos ningún dato. Si un cliente hace un pedido desde un catálogo, guardamos el detalle del pedido (productos, cantidades, total, fecha y forma de entrega) y, solo si los completa, su nombre, la dirección de entrega y las aclaraciones. Ese pedido lo ve únicamente el negocio en su cuenta, para poder atenderlo; el negocio es responsable del uso que les dé a esos datos.</p>
        </>
    },
    {
        id: "publico",
        title: "Qué es público",
        body: <p>Los datos de tu negocio y tus productos se muestran en tu catálogo, que puede ver cualquier persona con el link o el QR. Tu email y los datos de tu suscripción no aparecen en el catálogo.</p>
    },
    {
        id: "uso",
        title: "Para qué usamos los datos",
        body: <ul>
            <li>Crear y mostrar tu catálogo y tu código QR.</li>
            <li>Mostrarle a cada negocio los pedidos que recibió desde su catálogo.</li>
            <li>Activar, mantener o dar de baja tu plan Pro según lo que informe Mercado Pago.</li>
            <li>Enviarte avisos sobre tu cuenta o tu suscripción.</li>
            <li>Responder tus consultas y mejorar la Plataforma.</li>
        </ul>
    },
    {
        id: "terceros",
        title: "Servicios de terceros",
        body: <>
            <p>No vendemos ni compartimos tus datos con fines publicitarios. Para funcionar usamos estos proveedores, que tratan los datos solo para prestar su servicio:</p>
            <ul>
                <li><strong>Google Firebase:</strong> inicio de sesión y almacenamiento de los datos y las imágenes de tu catálogo.</li>
                <li><strong>Mercado Pago:</strong> cobro de la suscripción Pro. Los datos de pago los maneja Mercado Pago según su propia política de privacidad.</li>
                <li><strong>Servicios de alojamiento:</strong> los servidores donde se publica la Plataforma y donde se procesan los avisos de pago.</li>
            </ul>
            <p>También podemos compartir datos si una autoridad competente lo exige por ley.</p>
        </>
    },
    {
        id: "seguridad",
        title: "Almacenamiento y seguridad",
        body: <p>Los datos se guardan en los servidores de Google Firebase. Usamos conexiones cifradas y reglas de acceso para que solo vos puedas modificar tu negocio y tus productos. Aun así, ningún sistema es infalible, y tomamos medidas razonables para evitar accesos no autorizados.</p>
    },
    {
        id: "navegador",
        title: "Cookies y almacenamiento del navegador",
        body: <p>Guardamos en tu navegador lo necesario para mantener tu sesión iniciada y recordar si preferís el modo claro u oscuro. No usamos cookies de publicidad.</p>
    },
    {
        id: "conservacion",
        title: "Conservación",
        body: <p>Conservamos tus datos mientras tengas la cuenta. Si pedís la baja, eliminamos tu cuenta, tu negocio, tus productos y los pedidos que recibiste, salvo lo que la ley nos obligue a guardar.</p>
    },
    {
        id: "derechos",
        title: "Tus derechos",
        body: <>
            <p>Podés modificar los datos de tu negocio y tus productos cuando quieras desde tu cuenta. Para acceder a tus datos, corregirlos o pedir que los eliminemos, escribinos a <a href="mailto:contacto@miqrapp.com">contacto@miqrapp.com</a> desde el email de tu cuenta.</p>
            <p>Estos derechos están previstos en la Ley 25.326 de Protección de los Datos Personales. La Agencia de Acceso a la Información Pública, como órgano de control de esa ley, atiende las denuncias y reclamos por incumplimientos.</p>
        </>
    },
    {
        id: "cambios",
        title: "Cambios en esta Política",
        body: <p>Si cambiamos esta Política te avisamos por email o desde la Plataforma, y actualizamos la fecha de esta página.</p>
    }
];

const Privacy = () => {
  return (
    <InfoLayout
        title="Políticas de privacidad - MiQRapp"
        path="/politicas-de-privacidad"
        description="Qué datos recopila MiQRapp, para qué los usa, con quién los comparte y cómo podés pedir que los eliminemos."
        eyebrow="Legal"
        heading="Políticas de privacidad"
        subheading="Qué datos guardamos, para qué y cómo podés pedir que los borremos."
    >
        <LegalDoc
            updated="30 de octubre de 2026"
            sections={sections}
            related={{ to: "/terminos-y-condiciones", label: "Ver términos y condiciones" }}
        ></LegalDoc>
    </InfoLayout>
  )
}

export default Privacy
